import type { TcgRarityId } from "./types";

const parseCount = (value: string | undefined, fallback: number): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

/** CDN folders: tcg/{Rarity}/Card-1.webp … Card-N.webp */
export const TCG_RARITY_ORDER: readonly TcgRarityId[] = [
  "Standard",
  "Legendary",
  "Mythic",
  "Ultimate",
] as const;

export const TCG_RARITY_COUNTS: Record<TcgRarityId, number> = {
  Standard: parseCount(import.meta.env.VITE_TCG_STANDARD_COUNT, 63),
  Legendary: parseCount(import.meta.env.VITE_TCG_LEGENDARY_COUNT, 56),
  Mythic: parseCount(import.meta.env.VITE_TCG_MYTHIC_COUNT, 14),
  Ultimate: parseCount(import.meta.env.VITE_TCG_ULTIMATE_COUNT, 7),
};
